/* ------------------------------------------------------------------
   JAC'D UP CUSTOM - the made-to-order agreement in the cart.

   Everything here is made after it is ordered, so it cannot be resold
   and cannot be taken back. This puts that in front of the customer one
   last time before they pay, and - more usefully - RECORDS THAT THEY
   AGREED ON THE ORDER ITSELF as a cart attribute, so there is something
   to point at later rather than a claim that the page said so.

   WHY THIS IS SCRIPT AND NOT LIQUID. A checkbox that gates a button is
   interactive by definition; with scripts off it could not gate
   anything anyway. The notice that must always render regardless lives
   in Liquid instead, under the buy buttons on the product page.

   THE GAP, STATED PLAINLY. Apple Pay, Google Pay and Shop Pay buttons
   on a PRODUCT page go straight to checkout and never touch the cart,
   so those customers never see this. That is why the product-page line
   exists and why the refund policy is filled in - Shopify links it in
   the footer of every checkout page.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  var KEY  = 'jdTermsAccepted';
  var ATTR = 'Made-to-order terms';
  var TEXT = 'I understand these items are made to order and can’t be returned or exchanged.';

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  // sessionStorage throws in a locked-down browser; an unticked box is
  // the safe answer there, not an exception.
  function isOn() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setOn(v) {
    try { if (v) { sessionStorage.setItem(KEY, '1'); } else { sessionStorage.removeItem(KEY); } }
    catch (e) { /* nothing to do - the tick still holds for this page */ }
  }

  function record(v) {
    var attrs = {};
    attrs[ATTR] = v ? 'Accepted ' + new Date().toISOString() : '';
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { /* the gate still works; only the record is lost */ });
  }

  var seq = 0;

  function ctaHost(btn) {
    return btn.closest('.cart__ctas') || btn.closest('.cart__blocks') || btn.parentElement;
  }

  function build() {
    var id = 'jd-gate-' + (++seq);
    var wrap = document.createElement('div');
    wrap.className = 'jd-gate';

    var box = document.createElement('input');
    box.type = 'checkbox';
    box.id = id;
    box.checked = isOn();

    var lab = document.createElement('label');
    lab.setAttribute('for', id);
    lab.textContent = TEXT;

    wrap.appendChild(box);
    wrap.appendChild(lab);

    box.addEventListener('change', function () {
      setOn(box.checked);
      record(box.checked);
      sync();
    });
    return wrap;
  }

  function needsMount() {
    var btns = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < btns.length; i++) {
      var host = ctaHost(btns[i]);
      if (!host) continue;
      var scope = host.parentElement || host;
      if (!scope.querySelector('.jd-gate')) return true;
    }
    return false;
  }

  function mount() {
    var btns = document.querySelectorAll('[name="checkout"]');
    Array.prototype.forEach.call(btns, function (btn) {
      var host = ctaHost(btn);
      if (!host) return;
      var scope = host.parentElement || host;
      if (scope.querySelector('.jd-gate')) return;
      scope.insertBefore(build(), host);
    });
    sync();
  }

  function sync() {
    var on = isOn();
    Array.prototype.forEach.call(document.querySelectorAll('.jd-gate input'), function (b) {
      b.checked = on;
    });
    Array.prototype.forEach.call(
      document.querySelectorAll('[id^="dynamic-checkout"], .cart__dynamic-checkout-buttons'),
      function (el) { el.classList.toggle('jd-gate-off', !on); }
    );
  }

  // A disabled button tells the customer nothing. Let them press it, stop
  // the submit, and point at the thing they have not done yet.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[name="checkout"]');
    if (!btn || isOn()) return;
    e.preventDefault();
    e.stopPropagation();

    var host = ctaHost(btn);
    var scope = (host && host.parentElement) || document;
    var gate = scope.querySelector('.jd-gate') || document.querySelector('.jd-gate');
    if (!gate) return;

    gate.classList.remove('jd-gate--nudge');
    void gate.offsetWidth;            // restart the animation
    gate.classList.add('jd-gate--nudge');
    if (gate.scrollIntoView) gate.scrollIntoView({ block: 'nearest' });
    var box = gate.querySelector('input');
    if (box) box.focus();
  }, true);

  // The cart drawer rebuilds its own markup every time the cart changes,
  // which throws the gate away with it. Watch for that and put it back -
  // guarded by needsMount() so re-mounting cannot feed itself.
  var pending;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(function () { if (needsMount()) mount(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
